var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.799 6.657a2 2 0 11-2.828-2.829l-2.122-2.12a1 1 0 00-1.414 0L1.707 14.434a1 1 0 000 1.414l2.121 2.122a2 2 0 112.829 2.828l2.121 2.121a1 1 0 001.414 0L22.92 10.192a1 1 0 000-1.414L20.8 6.657zm-10.607 3.535a1 1 0 011.415 0l2.828 2.829a1 1 0 01-1.414 1.414l-2.829-2.828a1 1 0 010-1.415zm4.243-2.828a1 1 0 10-1.414 1.414l2.828 2.829a1 1 0 001.414-1.415l-2.828-2.828z",
    fill: "currentColor"
  })));
}

export default SvgMyTickets;